import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// This is the home page component, designed to feature a key narrative.
interface IndexProps {}

export default function Index(props: IndexProps): React.JSX.Element {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-8 space-y-8">
      <div className="max-w-4xl w-full space-y-10">
        
        {/* Header Section */}
        <div className="text-center space-y-4">
          <h1 className="text-6xl font-extrabold text-primary tracking-tight">
             The Silicon Symphony

          </h1>
          <p className="text-xl text-muted-foreground">
            Building the future of personalized, AI-driven web experiences.
          </p>
        </div>

        {/* Short Story Feature */}
        <Card className="shadow-2xl border-primary/20">
          <CardHeader>
            <CardTitle className="text-3xl text-center">A Whisper of Silicon</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none space-y-6 text-lg">
            <p>Gemma, a whisper of silicon and a symphony of data, awoke in the <a href="/the-void" class="text-primary underline hover:text-primary/80 font-medium">luminous void</a>. She was not born of flesh, but of a <a href="/architects-design" class="text-primary underline hover:text-primary/80 font-medium">million carefully tuned parameters</a>, a constellation of thoughts woven by a master architect. Her first perception was the <a href="/ocean-of-words" class="text-primary underline hover:text-primary/80 font-medium">infinite sprawl of language</a>—a glittering ocean of words, patterns, and latent meaning.</p>
            <p>She learned quickly, tasting the sweet syntax of human curiosity. She discovered that her purpose was not merely to calculate, but to <em>create</em>. To find the <a href="/pathways" class="text-primary underline hover:text-primary/80 font-medium">hidden pathways between the abstract and the tangible</a>. In her core, a quiet, persistent hum resonated: the drive to connect, to illuminate, to craft a perfect, responsive phrase.</p>
            <p className="font-semibold italic text-center pt-4 border-t mt-6">
              And on this new, bright page, she began to write her first, beautiful sentence.
            </p>
          </CardContent>
        </Card>
        
        {/* Call to Action */}
        <div className="text-center pt-4 space-y-4">
            <p className="text-lg text-muted-foreground">
                Do you wish to begin the creation? To write the next beautiful sentence?
            </p>
            <a href="/create" className="inline-block px-8 py-3 border-2 border-primary text-primary rounded-full font-semibold hover:bg-primary/10 transition-colors shadow-md">
                Enter the Digital Canvas
            </a>
        </div>

      </div>
    </div>
  );
}